import i18n from '../i18n';

/**
 * The BCP-47 tag for the app's UI LANGUAGE.
 *
 * Mirrors `utils/formatHistoryTime.js:14` — deliberately NOT the OS locale.
 * `toLocaleDateString(undefined, …)` resolves to whatever the machine is set
 * to, so a German UI on an English Mac renders "August 2026" and
 * "Monday, 31 August 2026". Everything the user reads as *app* text must go
 * through this instead.
 *
 * DATES may use it. TIMES that a parser has to read back must NOT — see
 * `calendarDates.formatTime`, which pins 'en-US' on purpose because
 * `TimeCombobox.parseTimeInput` only understands `a|am|p|pm` and ICU can emit
 * `vorm./nachm.` for de-DE.
 */
export function appDateLocale() {
  return i18n.language === 'de' ? 'de-DE' : 'en-US';
}

/**
 * The locale to hand `Intl`/`toLocaleTimeString` for a CLOCK LABEL that the
 * app must be able to parse back. Pinned, not derived. Named so the intent
 * survives the next person who "fixes the inconsistency".
 */
export const PARSEABLE_TIME_LOCALE = 'en-US';
